import React from 'react';
import Icon from '../Icon';
import svg from '../icons/close-thick.js';

const IconCloseThick = (props) => <Icon {...props} svg={svg} />;

IconCloseThick.displayName = 'IconCloseThick';

export default IconCloseThick;
